// Fichier : Page.js - Suppression des boutons "Plus d'informations" et Double Tableau Tarifs

import React, { useRef } from "react";
import styled from "styled-components";
import { FaInstagram, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

// Importez les images ou utilisez des placeholders comme précédemment
import Frame1 from "../Assets/Frame1.png";
import Frame2 from "../Assets/Frame2.png";
import Frame4 from "../Assets/Frame4.png";
import LogoClin from "../Assets/LogoClin.png";
import Frame from "../Assets/Frame.jpeg";
// === COLORS ===
const colors = {
  background: "#f3ece7", // Blanc cassé / Beige clair
  text: "#473c34", // Brun foncé pour le texte
  accent: "#cda395", // Terre cuite claire (boutons, accents)
  line: "#d7cbc4", // Ligne de séparation
  band: "#c69a87", // Bandeau Qui suis-je (Terre cuite foncé)
  dark: "#2f2c2b", // Pied de page (Noir/Gris très foncé)
};

const BOOKING_URL = "https://app.cal.eu/clindoeilinstitut";

// === BREAKPOINTS ===
const MOBILE_BREAKPOINT = "600px";

// === GLOBAL WRAPPER ===
const Wrapper = styled.div`
  width: 100vw;
  min-height: auto;
  background: ${colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  overflow-x: hidden;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid ${colors.line};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 5px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// --- HEADER STRUCTURE ---
const ContactInfoContainer = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  margin: 10px 0 10px 0;
  color: ${colors.text};
  font-size: 1.2rem;

  @media (max-width: 900px) {
    text-align: center;
    gap: 10px;
    font-size: 1rem;
    flex-wrap: wrap;
    margin: 10px 0 0 0;
  }
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.6;
  width: 25%;

  @media (max-width: 900px) {
    width: 45%;
    text-align: center;
    align-items: center;
    margin-bottom: 10px;
  }
`;

const InfoLine = styled.p`
  margin: 3px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 13px;
  }
`;

const Line = styled.div`
  width: 100%;
  max-width: 260px;
  height: 1px;
  background: ${colors.line};
  margin: 40px 0;
`;

const Nav = styled.div`
  display: flex;
  justify-content: center;
  gap: 25px;
  flex-wrap: wrap;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    gap: 15px;
    padding: 0 10px;
  }
`;

const NavItem = styled.p`
  color: ${colors.text};
  font-size: 15px;
  padding: 6px 12px;
  cursor: pointer;
  white-space: nowrap;

  &:first-child {
    background: ${colors.accent};
    color: white;
    border-radius: 6px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 13px;
  }
`;

const ImagePresentation = styled.div`
  width: 600px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid white;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 90%;
  }
`;

const ContainerText = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(149, 93, 8, 0.6);
  padding: 40px;
`;

const Quote = styled.h2`
  font-size: 2rem;
  color: white;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  color: ${colors.text};
  text-align: center;
  max-width: 700px;
  margin-top: 40px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1rem;
  }
`;

const Bull1 = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${colors.background};
  z-index: 100;
  position: absolute;
  top: -40px;
  right: -10px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 80px;
    width: 80px;
  }
`;

const Bull2 = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${colors.background};
  z-index: 100;
  position: absolute;
  top: 10px;
  right: -60px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 80px;
    width: 80px;
    top: 0px;
  }
`;
/* -----------------------------------------
   SECTION 2 — QUI SUIS-JE
------------------------------------------ */
const SectionQui = styled.section`
  width: 100%;
  background: ${colors.band};
  padding: 120px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

const SectionContent = styled.div`
  text-align: center;
  color: #fff6f2;
  max-width: 800px;
`;

const SectionTitle = styled.h2`
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 40px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1.8rem;
    margin-bottom: 30px;
  }
`;

const SectionText = styled.p`
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 25px;
  color: white;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1.05rem;
    margin-bottom: 25px;
  }
`;

const InfoButton = styled.a.attrs(() => ({
  target: "_blank",
  rel: "noopener noreferrer",
}))`
  padding: 10px 20px;
  margin-top: 15px;
  background-color: ${colors.accent};
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;

/* -----------------------------------------
   SECTION 3 — MES PRESTATIONS
------------------------------------------ */

const SectionPrestations = styled.section`
  width: 100vw;
  padding: 120px 0;
  display: flex;
  justify-content: center;
  background: ${colors.background};
`;

const SectionInner = styled.div`
  width: 100%;
  max-width: 1000px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1050px) {
    padding: 0 20px;
  }
`;

const PrestationsTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 400;
  color: ${colors.text};
  margin-bottom: 80px;
  text-align: center;

  @media (max-width: 700px) {
    font-size: 1.8rem;
    margin-bottom: 50px;
  }
`;

const CardsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 60px;
  }
`;

const Card = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 900px) {
    width: 90%;
  }
`;

const ImgPlaceholder = styled.div`
  width: 100%;
  height: 260px;
  border-radius: 6px;
  margin-bottom: 25px;
  border: 1px solid white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 220px;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 18px;
  color: ${colors.text};
`;

const CardText = styled.p`
  max-width: 95%;
  font-size: 1rem;
  line-height: 1.6;
  color: ${colors.text};
  /* Ajout d'une hauteur fixe pour un alignement visuel, ou suppression de la hauteur minimale */
  min-height: 100px; /* Maintenir la structure même sans bouton */

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    min-height: auto;
  }
`;

/* -----------------------------------------
   SECTION 4 — TARIFS DÉTAILLÉS
------------------------------------------ */

const TarifsSection = styled.section`
  width: 100vw;
  padding: 100px 0;
  display: flex;
  justify-content: center;
  background: ${colors.background};
`;

const TarifsInner = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
`;

const TarifsHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;

  h2 {
    font-size: 2.8rem;
    font-weight: 400;
    color: ${colors.accent};
    margin-bottom: 20px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 2rem;
    }
  }

  p {
    max-width: 700px;
    font-size: 1.1rem;
    line-height: 1.6;
    color: ${colors.text};
    margin: 10px 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 1rem;
    }
  }
`;

const TarifsGroup = styled.div`
  width: 100%;
  margin-bottom: 40px;
`;

const TarifsGroupTitle = styled.h3`
  background: ${colors.band};
  color: white;
  padding: 10px 20px;
  margin: 20px 0 0;
  font-size: 1.5rem;
  font-weight: 600;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  /* Retirer le border-radius s'il est suivi d'un tableau */
  ${({ noRadius }) => noRadius && "border-radius: 0;"}
`;

const TarifsTable = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin-top: 20px;
`;

const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid ${colors.line};
  background: ${({ isHeader }) => (isHeader ? colors.dark : "white")};
  color: ${({ isHeader }) => (isHeader ? "white" : colors.text)};
  font-weight: ${({ isHeader }) => (isHeader ? "600" : "400")};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Cell = styled.div`
  flex: ${({ size }) => size};
  text-align: left;

  &:nth-child(2) {
    /* Tarif */
    text-align: center;
  }

  &:nth-child(3) {
    /* Durée */
    text-align: right;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex: none;
    width: 100%;
    text-align: left !important;

    &.price {
      font-weight: 600;
      color: ${colors.accent};
      margin-top: 5px;
    }

    &.duration {
      font-size: 0.9em;
      color: #777;
      margin-top: 2px;
    }
  }
`;

const TarifsButton = styled(InfoButton)`
  margin-top: 50px;
  padding: 15px 35px;
  font-size: 1.1rem;
`;

/* -----------------------------------------
   FOOTER — REVIEWS ET CONTACT
------------------------------------------ */

const ReviewsSection = styled.section`
  width: 100%;
  background: ${colors.band};
  padding: 80px 20px 40px;
  text-align: center;
`;

const ReviewsButton = styled(InfoButton)`
  background-color: transparent;
  color: ${colors.dark};
  border: 2px solid ${colors.dark};
  padding: 10px 30px;
  margin-bottom: 40px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${colors.dark};
    color: white;
    opacity: 1;
  }
`;

const ReviewsGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  color: white;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

const ReviewCard = styled.div`
  flex: 1;
  max-width: 300px;
  font-style: italic;
  line-height: 1.5;

  cite {
    display: block;
    margin-top: 15px;
    font-style: normal;
    font-weight: bold;
  }
`;

const FooterWrapper = styled.footer`
  width: 100vw;
  background: ${colors.dark};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
`;

const FooterInner = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0 25px 40px;

  @media (max-width: 950px) {
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;
  }
`;

const FooterCol = styled.div`
  width: 25%;
  min-width: 180px;
  text-align: center;
  color: #e8d6cc;

  @media (max-width: 950px) {
    width: 40%;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
`;

const IconCircle = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: ${colors.accent};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  color: white;
  margin: 0 auto 15px auto;
  cursor: pointer;
`;

const FooterTitle = styled.h4`
  font-size: 1.1rem;
  margin-bottom: 10px;
  font-weight: 600;
  color: #e8d6cc;
`;

const FooterText = styled.p`
  font-size: 0.95rem;
  margin: 3px 0;
`;

const SocialIcons = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 15px;
  justify-content: center;

  a {
    color: white;
    font-size: 1.5rem;
    transition: color 0.3s;
    &:hover {
      color: ${colors.accent};
    }
  }
`;

const CopyrightBar = styled.div`
  width: 100%;
  max-width: 1000px;
  border-top: 1px solid #444;
  padding: 20px 25px;
  font-size: 0.8rem;
  color: #aaa;
  display: flex;
  justify-content: space-between;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
`;

const MapSection = styled.section`
  width: 100%;
  background: ${colors.band};
  padding: 80px 20px 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MapInner = styled.div`
  width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    width: 100%;
    height: auto;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 10px;
`;

const ContactLine = styled.p`
  font-size: 1.1rem;
  color: white;
  margin-top: 20px;
`;

// =======================================================================
// DONNÉES DE TARIFS
// =======================================================================

const ReflexologieTarifs = [
  // // Données de la capture Fanny Junger Réflexologie
  // {
  //   name: "Cheng Ren Séance sur-mesure pour adulte (< 12 ans)",
  //   price: "70 €",
  //   duration: "1h",
  // },
  // {
  //   name: "Xiao Er Séance sur-mesure pour enfant (de 3 à 12 ans)",
  //   price: "50 €",
  //   duration: "45min",
  // },
  // {
  //   name: "Yin Er Séance sur-mesure des touts petits (de 0 à 3 ans)",
  //   price: "40 €",
  //   duration: "30min",
  // },
  // {
  //   name: "Yun Fu Séance de réflexologie grossesse",
  //   price: "60 €",
  //   duration: "1h",
  // },
  // {
  //   name: "Chi Nei Tsang Massage abdominal taoïste",
  //   price: "70 €",
  //   duration: "1h",
  // },
];

const AutresServicesTarifs = {
  // Données de la capture Extensions de cils / Manucure
  "EXTENSIONS DE CILS - Pose complète": [
    { name: "Cil à cil (noir ou brun)", price: "65 €", duration: "1h30" },
    { name: "Pose mixte", price: "75 €", duration: "1h30" },
    { name: "Pose Foxy (effet liner)", price: "80 €", duration: "1h45" },
    { name: "Volume russe", price: "85 €", duration: "1h45" },
    { name: "Volume extrême / Wispy", price: "90 €", duration: "2h" },
  ],
  "Remplissage cils": [
    { name: "Cil à cil", price: "40 €", duration: "—" },
    { name: "Mixte", price: "45 €", duration: "—" },
    { name: "Volume russe / Foxy", price: "50 €", duration: "—" },
    { name: "Volume intense / Wispy", price: "60 €", duration: "—" },
  ],
  "BEAUTÉ DU REGARD": [
    { name: "Rehaussement + teinture", price: "60 €", duration: "1h" },
    {
      name: "Browlift + teinture (sans épilation)",
      price: "70 €",
      duration: "1h",
    },
    {
      name: "Combo Rehaussement + Browlift (avec teinture)",
      price: "120 €",
      duration: "1h15",
    },
    {
      name: "Combo Rehaussement + Browlift (sans teinture)",
      price: "110 €",
      duration: "1h",
    },
    { name: "Supplément épilation (à ajouter)", price: "10 €", duration: "—" },
  ],
  "SOIN VISAGE HYDRASKIN": [
    { name: "Sans luminothérapie", price: "70 €", duration: "1h" },
    { name: "Avec luminothérapie (30 min)", price: "90 €", duration: "1h30" },
  ],
  MANUCURE: [
    { name: "Semi-permanent", price: "30 €", duration: "1h" },
    { name: "Renfort + semi-permanent", price: "40 €", duration: "1h30" },
  ],
  SUPPLÉMENTS: [
    { name: "Épilation sourcils à la pince", price: "10 €", duration: "15min" },
    { name: "Jelly masque lèvres", price: "8 €", duration: "15min" },
  ],
};

// =======================================================================
// COMPOSANT PRINCIPAL (PAGE)
// =======================================================================

const Page = () => {
  const homeRef = useRef(null);
  const quiRef = useRef(null);
  const prestationsRef = useRef(null);
  const tarifsRef = useRef(null);
  const contactRef = useRef(null);

  const handleNavigation = (targetRef) => {
    targetRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const renderTarifsTable = (data) => (
    <TarifsTable>
      <TableRow isHeader>
        <Cell size={3}>Prestation</Cell>
        <Cell size={1} style={{ textAlign: "center" }}>
          Tarif
        </Cell>
        <Cell size={1} style={{ textAlign: "right" }}>
          Durée
        </Cell>
      </TableRow>
      {data.map((item, index) => (
        <TableRow key={index}>
          <Cell size={3}>{item.name}</Cell>
          <Cell size={1} className="price">
            {item.price}
          </Cell>
          <Cell size={1} className="duration">
            {item.duration}
          </Cell>
        </TableRow>
      ))}
    </TarifsTable>
  );

  const renderGroupedTarifs = (groups) => {
    const keys = Object.keys(groups);
    return keys.map((title, index) => (
      <TarifsGroup key={index}>
        <TarifsGroupTitle noRadius>{title}</TarifsGroupTitle>
        <TarifsTable>
          {/* Pas de header pour les sections détaillées comme dans la capture, on va juste lister */}
          {groups[title].map((item, itemIndex) => (
            <TableRow key={itemIndex}>
              <Cell size={3}>{item.name}</Cell>
              <Cell size={1} className="price">
                {item.price}
              </Cell>
              <Cell size={1} className="duration">
                {item.duration}
              </Cell>
            </TableRow>
          ))}
        </TarifsTable>
      </TarifsGroup>
    ));
  };

  return (
    <>
      {/* SECTION 1 - ACCUEIL */}
      <Wrapper ref={homeRef}>
        <Container>
          <Logo>
            <img src={LogoClin} alt="Logo" />
          </Logo>
          <ContactInfoContainer>
            <InfoBlock>
              {/* <InfoLine style={{ alignSelf: "flex-start" }}>
                Camille Boyah
              </InfoLine> */}
              <InfoLine style={{ alignSelf: "flex-start" }}>
                41 rue maréchal Ney 54140 jarville
              </InfoLine>
            </InfoBlock>
            <InfoBlock>
              <InfoLine style={{ alignSelf: "flex-end" }}>
                camilleboyat54@gmail.com
              </InfoLine>
              <InfoLine style={{ alignSelf: "flex-end" }}>
                07 66 02 54 55
              </InfoLine>
            </InfoBlock>
          </ContactInfoContainer>

          <Line />

          <Nav>
            <NavItem onClick={() => handleNavigation(homeRef)}>ACCUEIL</NavItem>
            <NavItem onClick={() => handleNavigation(quiRef)}>
              Qui suis-je ?
            </NavItem>
            <NavItem onClick={() => handleNavigation(prestationsRef)}>
              Mes prestations
            </NavItem>
            <NavItem onClick={() => handleNavigation(tarifsRef)}>
              Tarifs
            </NavItem>
            <NavItem onClick={() => handleNavigation(contactRef)}>
              Contact
            </NavItem>
          </Nav>
          <ImagePresentation>
            <Bull1 />
            <Bull2 />
            <img src={Frame} alt="Bannière Réflexologie" />
            <ContainerText>
              <Quote>
                La beauté du regard,  <br />
                c’est la douceur de l’âme.
              </Quote>
            </ContainerText>
          </ImagePresentation>
          <Subtitle>
            Sublimez votre regard et révélez votre beauté avec des prestations
            sur mesure.
          </Subtitle>
          <InfoButton href={BOOKING_URL}>
            Prendre rendez-vous en ligne
          </InfoButton>
        </Container>
      </Wrapper>

      {/* SECTION 2 — QUI SUIS-JE */}
      <SectionQui ref={quiRef}>
        <SectionContent>
          <SectionTitle>Qui suis-je ?</SectionTitle>
          <SectionText>
            Je suis Camille, fondatrice de Clin d’Œil Institut et spécialiste
            des extensions de cils à Nancy.   Passionnée par le regard et le
            bien-être, j’ai créé un espace dédié au naturel, à la précision et à
            l’élégance. Chaque pose est adaptée à votre morphologie et pensée
            pour sublimer votre regard en respectant vos cils.
          </SectionText>
          <SectionText>
            Formée aux techniques modernes (Wispy, Foxy, cils de couleur…),
            j’accorde une attention particulière au confort, à l’hygiène et au
            résultat.   J’ai également développé une expertise en soins visage,
            dont le Soin Hydraglow et la luminothérapie LED, pour révéler
            l’éclat de la peau.
          </SectionText>
          <SectionText>
            Ici, vous êtes accueillie avec douceur, écoute et professionnalisme.
          </SectionText>
        </SectionContent>
      </SectionQui>

      {/* SECTION 3 — MES PRESTATIONS (SANS BOUTONS) */}
      <SectionPrestations ref={prestationsRef}>
        <SectionInner>
          <PrestationsTitle>Mes prestations</PrestationsTitle>

          <CardsRow>
            <Card>
              <ImgPlaceholder>
                <img src={Frame2} alt="Séance de réflexologie" />
              </ImgPlaceholder>
              <CardTitle>Extensions de cils </CardTitle>
              <CardText>
                Mise en valeur du regard avec des poses sur mesure, adaptées à
                votre morphologie. Résultat élégant, durable et respectueux de
                vos cils naturels.
              </CardText>
              {/* BOUTON SUPPRIMÉ */}
            </Card>

            <Card>
              <ImgPlaceholder>
                <img src={Frame4} alt="Réflexologie grossesse" />
              </ImgPlaceholder>
              <CardTitle>Browlift / Lashlift </CardTitle>
              <CardText>
                Sourcils structurés et cils rehaussés pour un regard intensifié,
                naturel et longue tenue, sans extensions.
              </CardText>
              {/* BOUTON SUPPRIMÉ */}
            </Card>

            <Card>
              <ImgPlaceholder>
                <img src={Frame1} alt="Chi Nei Tsang" />
              </ImgPlaceholder>
              <CardTitle>Soins visage Hydraskin </CardTitle>
              <CardText>
                Soin complet pour nettoyer, hydrater et illuminer la peau.
                Possibilité d’ajouter la luminothérapie LED pour un éclat
                renforcé.
              </CardText>
              {/* BOUTON SUPPRIMÉ */}
            </Card>
          </CardsRow>
        </SectionInner>
      </SectionPrestations>

      {/* SECTION 4 — TARIFS DÉTAILLÉS (DOUBLE TABLEAU) */}
      <TarifsSection ref={tarifsRef}>
        <TarifsInner>
          <TarifsHeader>
            <h2 style={{ fontFamily: "Playfair Display, serif" }}>TARIFS</h2>
          </TarifsHeader>

          {renderGroupedTarifs(AutresServicesTarifs)}

          <TarifsButton href={BOOKING_URL}>Prendre rendez-vous</TarifsButton>
        </TarifsInner>
      </TarifsSection>

      {/* SECTION REVIEWS & FOOTER (Contact) */}
      <ReviewsSection>
        <ReviewsGrid>
          <ReviewCard>
            <a
              style={{ color: "red" }}
              href="https://app.cal.eu/clindoeilinstitut"
              target="_blank"
            />
            <p>
              "Je me suis rendu à l'institut pour plusieurs prestations, elles
              ont toutes été réalisées avec douceur, et selon mes préférences.
              En plus de cela le travail est réalisé rapidement contrairement à
              d'autre institut où la pose de cils dure trop longtemps. Je
              recommande les yeux fermés."
            </p>
          </ReviewCard>
          <ReviewCard>
            <p>
              "Quel plaisir de se faire chouchouter chez Camille ! C'est une
              professionnelle hors-pair, de très bon conseil, très précise, qui
              a le souci du détail ! Vous pouvez y aller les yeux fermés 😉,
              pour avoir été chez d'autres professionnels en extension de cils,
              je peux vous garantir que Camille fait un travail remarquable tout
              en respectant les cils naturels, ce qui n'est pas le cas de tous
              !"
            </p>
          </ReviewCard>
          <ReviewCard>
            <p>
              "Super, souriante, agréable ! Toujours disponible et arrangeante !
              Je recommande 1000 fois !!! Services : Microblading, Extensions de
              cils."
            </p>
          </ReviewCard>
        </ReviewsGrid>
      </ReviewsSection>

      <MapSection ref={contactRef}>
        <MapInner>
          <MapContainer>
            <iframe
              style={{ border: 0, width: "100%", height: "100%" }}
              // *** Ceci est le SRC que vous devez copier entièrement depuis Google Maps ***
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2634.996275137169!2d6.197639477244479!3d48.667313971307046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479498fa10d4975d%3A0x61831b066a70ef98!2s41%20Rue%20Mar%C3%A9chal%20Ney%2C%2054140%20Jarville-la-Malgrange!5e0!3m2!1sfr!2sfr!4v1765488517787!5m2!1sfr!2sfr"
            ></iframe>
          </MapContainer>
        </MapInner>
      </MapSection>

      <FooterWrapper ref={contactRef}>
        <FooterInner>
          {/* Colonne Adresse */}
          <FooterCol>
            <IconCircle>
              <FaMapMarkerAlt />
            </IconCircle>
            <FooterTitle>Adresse</FooterTitle>
            <FooterText>41 rue maréchal Ney 54140 jarville</FooterText>
            <FooterText>
              A proximité immédiate du collège/lycée La Malgrange et de la gare
              et de 4 lignes de bus. (T2, CAROL, 12 & 21)
            </FooterText>
          </FooterCol>

          {/* Colonne Téléphone - CLICQUABLE */}
          <FooterCol>
            <IconCircle onClick={() => window.open("tel:0766025455", "_blank")}>
              <FaPhone />
            </IconCircle>
            <FooterTitle>Téléphone</FooterTitle>
            <FooterText style={{ fontWeight: "600" }}>
              07 66 02 54 55
            </FooterText>
          </FooterCol>

          {/* Colonne Instagram - CLICQUABLE */}
          <FooterCol>
            <IconCircle
              onClick={() =>
                window.open(
                  "https://www.instagram.com/clindoeil.institut/reels/",
                  "_blank"
                )
              }
            >
              <FaInstagram />
            </IconCircle>
            <FooterTitle>
              <a
                style={{ color: "#e8d6cc", textDecoration: "none" }}
                href="https://www.instagram.com/clindoeil.institut/reels/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </FooterTitle>
          </FooterCol>
        </FooterInner>

        <CopyrightBar>
          <div>© 2025 Clin d’Œil Institut</div>
          <a
            style={{ color: "white", textDecoration: "none" }}
            href="https://inscalup.agency/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Propulsé par inscalup.agency
          </a>
        </CopyrightBar>
      </FooterWrapper>
    </>
  );
};

export default Page;
